import { Component, Inject, ViewChild } from '@angular/core';
import { DataTableComponent } from '../data-table/data-table.component';
import { DataTable } from '../data-table/data-table.interface';
import { DataTableService } from '../data-table/data-table.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-modal-confirmation-list',
  templateUrl: './modal-confirmation-list.component.html',
  styleUrls: ['./modal-confirmation-list.component.scss']
})
export class ModalConfirmationListComponent {

  @ViewChild(DataTableComponent) childDatatable: DataTableComponent;
  constructor(
    public dialogRef: MatDialogRef<ModalConfirmationListComponent>,
    private dataTableService: DataTableService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  onClose = () => this.dialogRef.close(false);

  onSubmitAction= () => {
    if (this.data.config.export) {
      this.onSubmiExport();
    } else {
      this.dialogRef.close(true)
    }
  };

  onSubmiExport = () => {
    const dataTemp = JSON.parse(JSON.stringify(this.data.data));
    const columns: DataTable = {
      ... this.childDatatable
        .getSchemaByType(this.data.type)
    };
    columns.exportFile = this.data.config.file;
    this.dataTableService.exportData(dataTemp, false, columns);
    this.dialogRef.close(false)
  }
}
